/**
 * match-frame-content-height.directive.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

import { Directive, ElementRef, HostListener, Input, OnInit }
    from "@angular/core";

const DEFAULT_RENDER_DELAY : number = 200;

@Directive({
    selector: "iframe[match-height]"
})
export class MatchFrameContentHeightDirective implements OnInit
{
    public frame : HTMLIFrameElement;

    @Input()
    public delay : number;

    constructor (public element : ElementRef) {}

    public ngOnInit () : void
    {
        if ((this.element.nativeElement as HTMLIFrameElement).contentDocument)
        {
            this.frame = this.element.nativeElement;
            console.warn("Found iframe document!");

            if (this.frame.contentDocument.readyState === "complete")
            {
                this.resize();
            }
            else
            {
                this.frame.contentDocument.addEventListener(
                    "load", () => this.resize());
            }
        }
    }

    private delayed (cb : () => void) : void
    {
        setTimeout(cb, this.delay || DEFAULT_RENDER_DELAY);
    }

    private resize () : void
    {
        this.delayed(
            () => this.frame.style.height =
                `${this.frame.contentDocument.body.scrollHeight}px`);
    }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/support/controls/match-frame-content-height.directive.ts